import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { FadeUp } from '@/components/motion/FadeUp'
import { SECTION_PY } from '@/lib/layoutSpacing'

interface SectionProps extends HTMLAttributes<HTMLElement> {
  title?: string
  subtitle?: string
  action?: ReactNode
  animate?: boolean
}

export function Section({
  title,
  subtitle,
  action,
  animate = true,
  className,
  children,
  ...props
}: SectionProps) {
  const content = (
    <section className={cn(SECTION_PY, className)} {...props}>
      {(title || action) && (
        <div className="mb-2.5 flex flex-col gap-1 sm:mb-3 sm:flex-row sm:items-center sm:justify-between md:gap-3">
          <div className="min-w-0">
            {title && (
              <h2 className="font-display text-[14px] font-bold leading-tight text-primary-700 md:text-lg lg:text-xl">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="mt-0.5 text-[11px] text-neutral-500 md:text-sm">{subtitle}</p>
            )}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  )

  return animate ? <FadeUp>{content}</FadeUp> : content
}
